import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import logo from "@assets/icons/cards.svg";
import logopaypal from "@assets/icons/paypal_logo.svg";
import zelle from "@assets/icons/zelle_pay.svg";
import venmo from "@assets/icons/venmo_pay.svg";
import { CartContext } from "@context/CardContext";
import axios from "@fetch/axios";
import { TokenContext } from "@context/TokenContext";
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import CheckoutForm from "./CheckoutForm";
import "../../styles/CheckStripe.scss"
import PayPaypal from "./PayPaypal";
import { useTranslation } from "@hooks/useTranslation";
import { LanguageCurrencyContext } from "@context/LanguageCurrencyContext";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import Spinner from "@components/Spinner";

const Component = () => {
  const MySwal = withReactContent(Swal)
  const navigate = useNavigate();
  const [selectedPayment, setSelectedPayment] = useState("tarjeta"); // Estado para controlar la selección
  const { getCardId, totalPay,setTotalPay,resetCart } = useContext(CartContext);
  const { getToken, getVerified } = useContext(TokenContext);
  const { lang, currency, cambiarCurrency } = useContext(LanguageCurrencyContext);
  const [clientSecret, setClientSecret] = useState("");
  const [stripePromise, setPublicKey] = useState("");
  const { translate } = useTranslation();
  const [loading, setLoading] = useState(true)
  const [resumeCurrency, setResumeCurrency] = useState(null);

  const appearance = {
    theme: 'stripe',
  };
  const loader = 'auto';

    const fetchCarrito = async () => {

    if (localStorage.getItem('cartId') !== null) {

      try {
        setLoading(false);
        const res = await axios.get('/cart/resume-order?currency='+currency+'&lang='+lang+'&id=' + localStorage.getItem('cartId') + '&verified=' + (getVerified() ? 1 : 0),
          {
            headers: { 'Authorization': 'Bearer ' + getToken() }
          }
        );
        setLoading(true);

        if (res.data) {
          setTotalPay(res.data.total);
          setResumeCurrency(currency);
        }


      } catch (error) {
        setLoading(true)
        console.log('Error fetching address list', error);
      }

    }

  };

  useEffect(() => {

    fetchCarrito();

    const fetchStripeKey = async () => {

      try {

        if (getCardId()) {
          const res = await axios.get('/cart/stripe/payment?cart_id=' + getCardId() + '&verified=' + (getVerified() ? 1 : 0), {
            headers: { 'Authorization': 'Bearer ' + getToken() }
          });
          if (res.data) {

            setClientSecret(res.data.client_secret)
            setPublicKey(loadStripe(res.data.public_key))

          } else {

            MySwal.fire({
              text: translate('stripe.error1'),
              icon: 'error',
              title: 'Oops...'
            })

          }

        }

      } catch (error) {

        MySwal.fire({
          text: translate('stripe.error2'),
          icon: 'error',
          title: 'Oops...'
        })
        // navigate('/carrito')
      }
    };

    fetchStripeKey();

  }, [currency]);

  useEffect(() => {
    if (resumeCurrency !== currency) return;

    const controller = new AbortController();
    let fetching = false;

    const interval = setInterval(async () => {
      const cartId = localStorage.getItem('cartId');
      if (!cartId || fetching) return;

      fetching = true;
      try {
        const res = await axios.get('/cart/resume-order', {
          params: { currency, lang, id: cartId, verified: getVerified() ? 1 : 0 },
          headers: { 'Authorization': 'Bearer ' + getToken() },
          signal: controller.signal
        });

        if (controller.signal.aborted || localStorage.getItem('cartId') !== cartId) return;

        const total = res.data?.total;
        if (typeof total === 'string' && total !== '' && total !== totalPay) {
          clearInterval(interval);
          window.location.href = '/checkout-envio';
        }
      } catch (error) {
        if (!controller.signal.aborted) {
          console.error('Error validating order total', error);
        }
      } finally {
        fetching = false;
      }
    }, 3500);

    return () => {
      clearInterval(interval);
      controller.abort();
    };
  }, [currency, lang, totalPay, resumeCurrency, getToken, getVerified]);

  const enviaraPendiente = async () => {


    try {

      if (getCardId()) {

        setLoading(false);

        const res = await axios.post(`/cart/zelleyvenmo-payment?lang=${lang}`,
          {
            "cart_id": getCardId(),
            "payment_method": selectedPayment
          },
          {
            headers: { 'Authorization': 'Bearer ' + getToken() }
          });

        setLoading(true)
        if (res.data) {

          if (res.data.message == 'Payment pending confirmation') {

            localStorage.setItem('cartId', '')
            resetCart();
            navigate('/checkout-pendiente')

          }

        } else {

          MySwal.fire({
            text: translate('stripe.error1'),
            icon: 'error',
            title: 'Oops...'
          })
        }

      }

    } catch (error) {
      setLoading(true);
    }

  }

  return (
    <>
      {!loading && <Spinner />}
      <section className="CheckoutBox">

        <article>
          <div className="StepCheckout">
            <div className="Selected" onClick={() => navigate('/checkout-guest')} style={{ cursor: "pointer" }}></div>
            <div className="Selected" onClick={() => navigate('/checkout-envio')} style={{ cursor: "pointer" }}></div>
            <div className="Selected" onClick={() => navigate('/checkout-resumen')} style={{ cursor: "pointer" }}></div>
            <div className="Selected"></div>
          </div>
          <div className="icon-Wallet" onClick={() => navigate('/carrito')} style={{ cursor: "pointer" }}></div>
          <div className="line">
            <h5>{translate('checkout.information')}</h5>
            <div className="box-price">
              <span>Total:</span>
              <div className="price">${totalPay}</div>
              <a href="#" onClick={(e) => { e.preventDefault(); navigate('/checkout-resumen'); }}
              >
                {translate('summary.see')}
              </a>
            </div>
          </div>

          {/* Opción Tarjeta */}
          <div className="TarjetasGuardadas">
            <div>{translate('checkout.credicard')}</div>
            <label className="ItemTarjeta">
              <input
                type="radio"
                name="payment"
                checked={selectedPayment === "tarjeta"}
                onChange={() => setSelectedPayment("tarjeta")}
              />
              <div className="Selected">
                <div>
                  <img src={logo} alt="logo tarjeta" />
                </div>
              </div>
            </label>
          </div>
          {selectedPayment === "tarjeta" && (
            <div className="FormTarjeta">
              {clientSecret && (
                <Elements options={{ clientSecret, appearance, loader }} stripe={stripePromise}>
                  <CheckoutForm />
                </Elements>
              )}
            </div>
          )}

          {/* Opción PayPal */}
          <div className="TarjetasGuardadas">
            <div>PayPal</div>
            <div className="FontSmall">
              {translate('checkout.paypal')}
            </div>
            <label className="ItemTarjeta">
              <input
                type="radio"
                name="payment"
                checked={selectedPayment === "paypal"}
                onChange={() => setSelectedPayment("paypal")}
              />
              <div className="Selected">
                <div>
                  <img src={logopaypal} alt="logo paypal" />
                </div>
              </div>
            </label>
          </div>
          {selectedPayment === "paypal" && (
            <PayPaypal />
          )}

          {currency == 'mxn' && <div className="TarjetasGuardadas cont-payzellevenmo">
            <div className="FontSmall">
              {translate('checkout.payzellevenmo')}
            </div>
            <button className="ButtonDarkMedium" onClick={() => cambiarCurrency('usd')} >
              {translate('checkout.payzellevenmo_btn')}
            </button>
          </div>}

          {currency == 'usd' && (
            <>
              {/* Opción Zelle */}
              <div className="TarjetasGuardadas">
                <div>Zelle</div>
                <label className="ItemTarjeta">
                  <input
                    type="radio"
                    name="payment"
                    checked={selectedPayment === "zelle"}
                    onChange={() => setSelectedPayment("zelle")}
                  />
                  <div className="Selected">
                    <img src={zelle} alt="logo zelle" />
                  </div>
                </label>
              </div>

              {/* Opción Venmo */}
              <div className="TarjetasGuardadas">
                <div>Venmo</div>
                <label className="ItemTarjeta">
                  <input
                    type="radio"
                    name="payment"
                    checked={selectedPayment === "venmo"}
                    onChange={() => setSelectedPayment("venmo")}
                  />
                  <div className="Selected">
                    <img src={venmo} alt="logo venmo" />
                  </div>
                </label>
              </div>

              {(selectedPayment === "zelle" || selectedPayment === "venmo") && (
                <div className="FormButtonZelle" onClick={() => { enviaraPendiente() }}>
                  <a
                    href="#modal-aviso-pay"
                    data-type="inline"
                    className="ButtonDarkMedium"
                  >
                    {translate('checkout.venmozelle')}
                  </a>
                </div>
              )}
            </>
          )}

        </article>
      </section>
    </>
  );

};

export default Component;
